module.exports = __webpack_public_path__ + "ad4a5b17bf04c2890ec2301d97b2f834.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/climbs/climb_4.png
// module id = 1798
// module chunks = 1